// extracted by mini-css-extract-plugin
module.exports = {"container":"pageTemplate_container__2eKfA","content":"pageTemplate_content__IuDGb"};